import { render } from "./admin-category.vue?vue&type=template&id=103d6567&scoped=true&ts=true"
import script from "./admin-category.vue?vue&type=script&lang=ts"
export * from "./admin-category.vue?vue&type=script&lang=ts"

import "./admin-category.vue?vue&type=style&index=0&id=103d6567&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103d6567"]])

export default __exports__